import { useAppStore } from '@/store/useAppStore';
import { Select } from 'calc-controls';

export function SchoolContextPanel() {
  const context = useAppStore((s) => s.schoolContext);
  const updateContext = useAppStore((s) => s.updateContext);

  return (
    <div className="rounded-lg border border-border bg-surface p-4" data-testid="school-context-panel">
      <h3 className="mb-3 text-sm font-semibold text-[var(--color-text)]">School Context</h3>

      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <label htmlFor="school-name" className="mb-1 block text-xs text-[var(--color-text-secondary)]">School Name</label>
          <input
            type="text"
            id="school-name"
            value={context.schoolName}
            onChange={(e) => updateContext({ schoolName: e.target.value })}
            className="w-full rounded-md border border-border px-3 py-2 text-sm"
            placeholder="Enter your school name"
            data-testid="input-school-name"
          />
        </div>

        <div>
          <label className="mb-1 block text-xs text-[var(--color-text-secondary)]">District Competitiveness</label>
          <Select
            inline
            label="District Competitiveness"
            value={context.districtCompetitiveness}
            onChange={(v) => updateContext({ districtCompetitiveness: v as 'low' | 'average' | 'high' | 'very_high' })}
            options={[
              { value: 'low', label: 'Low' },
              { value: 'average', label: 'Average' },
              { value: 'high', label: 'High' },
              { value: 'very_high', label: 'Very High' },
            ]}
          />
        </div>

        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="limitedAP"
            checked={context.limitedAP}
            onChange={(e) => updateContext({ limitedAP: e.target.checked })}
            className="h-4 w-4 rounded border-border"
            data-testid="checkbox-limited-ap"
          />
          <label htmlFor="limitedAP" className="text-xs text-[var(--color-text-secondary)]">
            Limited AP offerings at my school
          </label>
        </div>

        {context.limitedAP && (
          <div>
            <label htmlFor="ap-details" className="mb-1 block text-xs text-[var(--color-text-secondary)]">AP Details</label>
            <input
              type="text"
              id="ap-details"
              value={context.limitedAPDetails ?? ''}
              onChange={(e) => updateContext({ limitedAPDetails: e.target.value })}
              className="w-full rounded-md border border-border px-3 py-2 text-sm"
              placeholder="e.g., School offers only 5 AP courses"
              data-testid="input-limited-ap-details"
            />
          </div>
        )}

        <div className="sm:col-span-2">
          <label htmlFor="grading-quirks" className="mb-1 block text-xs text-[var(--color-text-secondary)]">Grading Notes</label>
          <input
            type="text"
            id="grading-quirks"
            value={context.gradingQuirks ?? ''}
            onChange={(e) => updateContext({ gradingQuirks: e.target.value })}
            className="w-full rounded-md border border-border px-3 py-2 text-sm"
            placeholder="e.g., School weights Honors same as AP"
          />
        </div>

        <div className="sm:col-span-2">
          <label htmlFor="school-notes" className="mb-1 block text-xs text-[var(--color-text-secondary)]">Additional Notes</label>
          <textarea
            id="school-notes"
            value={context.notes ?? ''}
            onChange={(e) => updateContext({ notes: e.target.value })}
            className="w-full rounded-md border border-border px-3 py-2 text-sm"
            rows={2}
            placeholder="Anything else worth noting about how your school grades or weights courses."
          />
        </div>
      </div>
    </div>
  );
}
